import { cva } from "class-variance-authority"

export const toastCva = cva(["bg-(--color-background)", "shadow-md", "ring-1", "ring-(--base-6)", "dark:bg-(--base-2)"])
